module.exports = __webpack_public_path__ + "static/img/11.f7e6b7f.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/3/6/eng/11.png
// module id = AvV3
// module chunks = 0